export const UnderlineSvg = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14625_31246)">
        <path
          d="M12.9615 0C12.4093 0 11.9615 0.447715 11.9615 1V8.97932C11.9615 9.83009 11.7692 10.4572 11.3439 10.8604C10.9185 11.2638 10.322 11.4653 9.53432 11.4653C8.74033 11.4653 8.12573 11.2621 7.69088 10.8556C7.25611 10.4492 7.0385 9.82385 7.0385 8.97921V0.999999C7.0385 0.447714 6.59078 0 6.0385 0H4.80772C4.25543 0 3.80772 0.447715 3.80772 1V8.97932C3.80772 10.5485 4.34918 11.7648 5.39526 12.6281C6.44126 13.4916 7.82748 13.9231 9.53525 13.9231C11.2241 13.9231 12.5875 13.4916 13.6306 12.6281C14.6734 11.7648 15.1924 10.5485 15.1924 8.97932V1C15.1924 0.447716 14.7446 0 14.1924 0H12.9615Z"
          fill="currentColor"
        />
        <path
          d="M17.05 16.1499H1.65383C1.10155 16.1499 0.653831 16.5976 0.653831 17.1499V17.9999C0.653831 18.5521 1.10155 18.9999 1.65383 18.9999H17.05C17.6023 18.9999 18.05 18.5521 18.05 17.9999V17.1499C18.05 16.5976 17.6023 16.1499 17.05 16.1499Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
